export class GranularityModel {
    id: number;
    display_labels: { [key: string]: string };
    granularity_name: string;
    code: string;
    duration_in_minutes: string;
    duration_in_milliseconds: string;
}